module.exports = __webpack_public_path__ + "event-bg.ca7e587443449c5ae6c1.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/assets/img/news/event-bg.png
// module id = ../../../../../src/assets/img/news/event-bg.png
// module chunks = main